/**
 * Builds the URL used to enter a stand-in (local server) instance from the org-picker
 * "Offline Mode" entry.
 *
 * Deliberately carries no org hint: entering stand-in is a fresh login against the local
 * server, which owns org selection — its org token differs from the cloud org id (see
 * `standInLocalOrgToken`), so a cloud `organizationId` would suppress the default selection
 * with an id that does not exist there. Falls back to the raw base URL if it cannot be parsed.
 *
 * `devWebAppUrl` (dev-only, from the `?standinWebAppUrl=` param on localhost) simulates the
 * stand-in-served SPA from a local dev server: navigation targets that URL instead, carrying
 * `baseUrl`/`webSocketUrl` params that repoint its SDK at the org's stand-in API.
 */
export function buildStandinUrl(baseUrl: string, devWebAppUrl?: string): string {
  try {
    if (devWebAppUrl) {
      const url = new URL(devWebAppUrl);
      url.searchParams.set('baseUrl', baseUrl);
      url.searchParams.set('webSocketUrl', baseUrl);
      return url.toString();
    }
    return new URL(baseUrl).toString();
  } catch {
    return baseUrl;
  }
}

export default buildStandinUrl;
